import TableDynamic from "../../components/TableDynamic";
import React from "react";
import { Dropdown } from "react-bootstrap";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { store } from "../../reducer/Store";
import Utils from "../../services/Utils";
import ApiService from "../../services/ApiService";
import YearsModal from "../../components/years/YearsModal";
const Years = () => {
  const { dispatch, state } = React.useContext(store);
  const [show, setShow] = React.useState(false);
  const [year, setYear] = React.useState(new Date().getFullYear() + 1);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [duplicatePlvs, setDuplicatePlvs] = React.useState(true);
  const [duplicatePlvTypes, setDuplicatePlvTypes] = React.useState(true);
  const [duplicateComToolTypes, setDuplicateComToolTypes] =
    React.useState(true);
  const [duplicatePrestataires, setDuplicatePrestataires] =
    React.useState(true);
  const [duplicateKams, setDuplicateKams] = React.useState(true);
  const [duplicateAmbassadrices, setDuplicateAmbassdrices] =
    React.useState(true);
  const [duplicateOperationsTypes, setDuplicateOperationsTypes] =
    React.useState(true);

  const handleClose = () => {
    setShow(false);
    setYear(new Date().getFullYear() + 1);
    setErrorMessage("");
    setDuplicatePlvs(true);
    setDuplicatePlvTypes(true);
    setDuplicateComToolTypes(true);
    setDuplicatePrestataires(true);
    setDuplicateAmbassdrices(true);
    setDuplicateOperationsTypes(true);
    setDuplicateKams(true);
  };
  const handleShow = () => setShow(true);
  const columnsName = [
    `Années ( ${
      state.listYears ? state.listYears.length + " en cours" : ""
    }  )`,
  ];
  const columns = ["label"];

  /**
   * Cette fonction récupère la liste des années à partir de l'API et la stocke dans le state de l'application.
   * @returns {void}
   */
  const getYears = async () => {
    var options = [];
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request({}, "years", "get")
      .then(function (response) {
        response.data.map((year) =>
          options.push({ value: year.id, label: year.name })
        );
        dispatch({
          type: "SET_LISTYEARS",
          payload: options,
        });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };
  /**
   * Fonction asynchrone pour ajouter une année.
   * Cette fonction envoie une requête API pour créer une nouvelle année en utilisant les informations fournies.
   * Elle utilise le hook useState pour mettre à jour l'état du loader en cours d'exécution et afficher un message d'erreur si la création échoue.
   * Si l'année existe déjà, elle affiche un message d'erreur approprié.
   * @returns {void}
   */
  const addYear = async () => {
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        name: year,
        duplicate_plv: duplicatePlvs,
        duplicate_plv_type: duplicatePlvTypes,
        duplicate_com_tool_types: duplicateComToolTypes,
        duplicate_providers: duplicatePrestataires,
        duplicate_kams: duplicateKams,
        duplicate_ambassadrices: duplicateAmbassadrices,
        duplicate_operation_types: duplicateOperationsTypes,
        user_email: JSON.parse(localStorage.getItem("user"))[1],
      },
      "years",
      "post"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        Utils.notifyInProgress(
          "Vous allez recevoir un email, cela peut prendre quelques minutes..."
        );
        handleClose();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        Utils.notifyError("la création d'une année.");
        console.log(error);
        if (error.response.data.message.includes("already exists")) {
          setErrorMessage("Cette année existe déjà.");
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };
  React.useEffect(() => {
    getYears();
  }, []);
  return (
    <>
      <h1>
        Années
        <Dropdown className="d-inline-block">
          <Dropdown.Toggle>
            <MoreVertIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleShow}>
              Ajouter une année
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </h1>
      {show && (
        <YearsModal
          handleClose={handleClose}
          show={show}
          addYear={addYear}
          errorMessage={errorMessage}
          loader={state.loader}
          year={year}
          duplicatePlvs={duplicatePlvs}
          duplicatePlvTypes={duplicatePlvTypes}
          duplicateOperationsTypes={duplicateOperationsTypes}
          duplicateComToolTypes={duplicateComToolTypes}
          duplicatePrestataires={duplicatePrestataires}
          duplicateKams={duplicateKams}
          duplicateAmbassadrices={duplicateAmbassadrices}
          setDuplicatePlvs={setDuplicatePlvs}
          setDuplicatePlvTypes={setDuplicatePlvTypes}
          setDuplicateOperationsTypes={setDuplicateOperationsTypes}
          setDuplicateComToolTypes={setDuplicateComToolTypes}
          setDuplicatePrestataires={setDuplicatePrestataires}
          setDuplicateKams={setDuplicateKams}
          setDuplicateAmbassdrices={setDuplicateAmbassdrices}
        />
      )}
      <TableDynamic
        columnsName={columnsName}
        columns={columns}
        data={state.listYears}
      ></TableDynamic>
    </>
  );
};

export default Years;
